import React from 'react'

const DownArrowIcon = ({ color }) => {
    return (
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.332031 0.373779L4.83203 4.37378L9.33203 0.37378" stroke={color ? '#315D99' : '#000'} />
        </svg>
    )
}

export default DownArrowIcon